"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACK_EVENT = void 0;
exports.TRACK_EVENT = '@tracking/TRACK_EVENT';